import { AppState } from '../../app/state/AppState';
import { FeatureFlags } from '../../ts/FeatureFlags';

export function selectFlowsOnSiteEnabled(state: AppState) {
  return FeatureFlags.maestroServerV1Enabled && state.session.info.site.flowsOnSiteEnabled !== false;
}
